
// import React, { useState, useEffect, useRef } from "react";
// import { Box, Typography, TextField, MenuItem, Slider, Button } from "@mui/material";
// import { get_city } from "../../api/ControllApi";

// const FilterDataCard = ({ onFilterChange, PropertyType, priceMin,
//   stateList,
//   priceMax,
//   areaMin,
//   areaMax }) => {



//   const safePropertyType = Array.isArray(PropertyType) ? PropertyType : [];
//   const safeStateList = Array.isArray(stateList) ? stateList : []





//   const [city, setCity] = useState("");
//   const [states, setState] = useState("")
//   const [plotType, setPlotType] = useState("");

//   const [searchQuery, setSearchQuery] = useState("");

//   const [priceRange, setPriceRange] = useState([
//     Number(priceMin) || 500,
//     Number(priceMax) || 5000000
//   ]);

//   const [areaRange, setAreaRange] = useState([
//     Number(areaMin) || 592,
//     Number(areaMax) || 100000
//   ]);



//   useEffect(() => {
//     if (priceMin != null && priceMax != null) {
//       setPriceRange([Number(priceMin), Number(priceMax)]);
//     }
//     if (areaMin != null && areaMax != null) {
//       setAreaRange([Number(areaMin), Number(areaMax)]);
//     }
//   }, [priceMin, priceMax, areaMin, areaMax]);



//   const [cities, setCities] = useState([])

//   const plotTypes = ["Residential", "Commercial", "Industrial"];

//   const handlePriceChange = (event, newValue) => {
//     // ensure newValue is always an array of numbers
//     if (Array.isArray(newValue)) {
//       setPriceRange(newValue.map(Number));
//     }
//   };

//   const handleAreaChange = (event, newValue) => {
//     setAreaRange(newValue);
//   };






//   const valueBox = {
//     flex: 1,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: 0.5,
//     backgroundColor: "#FFFFFF",
//     px: 1,
//     py: 0.5,
//     borderRadius: 1,
//     whiteSpace: "nowrap",
//   };
//   //formatPrice
//   // const formatPriceInLac = (value) => {
//   //   return (value / 100000).toFixed(2) + " Lac";
//   // };
//   const firstRender = useRef(true);

//   // Only trigger API after user changes something
//   useEffect(() => {
//     if (firstRender.current) {
//       firstRender.current = false;
//       return; // skip first render
//     }

//     const filters = {};

//     if (city) filters.city = city;
//     if (plotType) filters.plotType = plotType;
//     if (states) filters.states = states;
//     if (searchQuery) filters.searchQuery = searchQuery;

//     // Only include price/area if changed by user
//     if (priceRange[0] !== (Number(priceMin) || 500) || priceRange[1] !== (Number(priceMax) || 5000000)) {
//       filters.priceRange = priceRange;
//     }
//     if (areaRange[0] !== (Number(areaMin) || 592) || areaRange[1] !== (Number(areaMax) || 100000)) {
//       filters.areaRange = areaRange;
//     }

//     if (Object.keys(filters).length > 0) {
//       const timer = setTimeout(() => {
//         onFilterChange(filters);
//       }, 700);
//       return () => clearTimeout(timer);
//     }
//   }, [city, plotType, states, searchQuery, priceRange, areaRange]);


//   // useEffect(() => {
//   //   if (isFirstRender.current) {
//   //     isFirstRender.current = false;
//   //     return; // skip first render
//   //   }

//   //   const timer = setTimeout(() => {
//   //     onFilterChange?.({
//   //       city: city || undefined,
//   //       plotType: plotType || undefined,
//   //       priceRange,
//   //       areaRange,
//   //       searchQuery,
//   //       states: states || undefined,
//   //     });
//   //   }, 700);

//   //   return () => clearTimeout(timer);
//   // }, [city, plotType, priceRange, areaRange, searchQuery, states]);





//   // useEffect(() => {
//   //   if (safePropertyType.length > 0 && !plotType) {
//   //     setPlotType(safePropertyType[0].id);
//   //   }
//   // }, [safePropertyType]);



//   const getCity = (id) => {

//     get_city(id)
//       .then((res) => {
//         setCities(res?.data)
//       })
//       .catch((err) => {

//       })

//   };

//   useEffect(() => {
//     if (states) {
//       setCity("");
//       getCity(states);
//     } else {
//       setCities([]);
//       setCity("");
//     }
//   }, [states]);


//   const handleReset = () => {
//     setCity("");
//     setState("");
//     setPlotType("");
//     setSearchQuery("");
//     setPriceRange([Number(priceMin) || 500, Number(priceMax) || 5000000]);
//     setAreaRange([Number(areaMin) || 592, Number(areaMax) || 100000]);
//     onFilterChange({});
//   };


//   return (
//     <Box
//       sx={{
//         width: { lg: 300, sm: "auto-fit", xs: "auto-fit" },
//         py: 5,
//         px: 5,
//         m: "auto",
//         backgroundImage: `url("assets/images/plootbg.png")`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//         borderRadius: 6,
//         boxShadow: 3,
//         color: "black",
//       }}
//     >
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <Typography sx={{ fontWeight: "600", fontSize: { xs: 14, md: 17 } }}>
//           Filter
//         </Typography>
//         <img src="/assets/images/plotmarket_filter.png" width={112} />
//       </Box>

//       {/* City Dropdown */}

//       <Box mb={4}>
//         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//           Search
//         </Typography>
//         <TextField
//           placeholder="Search Plot"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           fullWidth
//           size="small"
//           variant="outlined"
//         />
//       </Box>

//       <Box mb={4}>
//         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//           State
//         </Typography>
//         <TextField
//           select
//           value={states}
//           onChange={(e) => setState(e.target.value)}
//           fullWidth
//           size="small"
//           variant="outlined"
//         >
//           {safeStateList.map((c, index) => (
//             <MenuItem key={index} value={c?.id}>
//               {c?.state_name}
//             </MenuItem>
//           ))}
//         </TextField>
//       </Box>

//       <Box mb={4}>
//         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//           City
//         </Typography>
//         <TextField
//           select
//           value={city}
//           onChange={(e) => setCity(e.target.value)}
//           fullWidth
//           size="small"
//           variant="outlined"
//         >
//           {cities.map((c, index) => (
//             <MenuItem key={index} value={c?.id}>
//               {c?.city_name}
//             </MenuItem>
//           ))}
//         </TextField>
//       </Box>

//       <Box mb={4}>
//         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//           Plot Type
//         </Typography>
//         <TextField
//           select
//           value={plotType || ""}
//           onChange={(e) => setPlotType(e.target.value)}
//           fullWidth
//           size="small"
//           variant="outlined"
//         >
//           {safePropertyType.map((type, index) => (
//             <MenuItem key={index} value={type?.id}>
//               {type?.category_name}
//             </MenuItem>
//           ))}
//         </TextField>
//       </Box>

//       <Box mb={3}>
//         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//           Price Range (₹ per sqft)
//         </Typography>

//         <Slider
//           value={priceRange}
//           onChange={handlePriceChange}
//           min={Number(priceMin) || 500}
//           max={Number(priceMax) || 5000000}
//           step={500000}
//           valueLabelDisplay="auto"
//         />

//         <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
//           <TextField
//             label="Min"
//             type="number"
//             value={priceRange[0]}
//             onChange={(e) => {
//               const val = Math.max(Number(priceMin) || 500, Math.min(Number(e.target.value) || 0, priceRange[1]));
//               setPriceRange([val, priceRange[1]]);
//             }}
//           />

//           <TextField
//             label="Max"
//             type="number"
//             value={priceRange[1]}
//             onChange={(e) => {
//               const val = Math.min(Number(priceMax) || 5000000, Math.max(Number(e.target.value) || 0, priceRange[0]));
//               setPriceRange([priceRange[0], val]);
//             }}
//           />

//         </Box>
//       </Box>



//       <Box mb={3}>
//         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//           Area (Sq Ft)
//         </Typography>

//         <Slider
//           value={areaRange}
//           onChange={handleAreaChange}
//           min={Number(areaMin) || 592}
//           max={Number(areaMax) || 100000}
//           step={100}
//           valueLabelDisplay="auto"
//         />



//         <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
//           <Box sx={valueBox}>
//             <Typography variant="caption">Min:</Typography>
//             {/* <Typography variant="body2" sx={{ color: "#75AE5B" }}>{areaRange[0]} Sqft</Typography> */}
//             <Typography variant="body2" sx={{ color: "#75AE5B" }}>
//               {(areaRange || [areaMin, areaMax])[0]} Sqft
//             </Typography>
//           </Box>

//           <Box sx={valueBox}>
//             <Typography variant="caption">Max:</Typography>
//             {/* <Typography variant="body2" sx={{ color: "#75AE5B" }}>{areaRange[1]} Sqft</Typography> */}
//             <Typography variant="body2" sx={{ color: "#75AE5B" }}>
//               {(areaRange || [areaMin, areaMax])[1]} Sqft
//             </Typography>
//           </Box>
//         </Box>
//       </Box>

//       <Box mt={3} sx={{ textAlign: "center" }}>
//         <Button variant="outlined" color="secondary" onClick={handleReset}>
//           Reset Filters
//         </Button>
//       </Box>



//     </Box>
//   );
// };

// export default FilterDataCard;

import React, { useState, useEffect, useRef } from "react";
import { Box, Slider, TextField, Typography, MenuItem, Button, Checkbox, ListItemText, Paper, Chip } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { CheckBoxOutlineBlank, CheckBox } from "@mui/icons-material";
import { get_country, get_state, get_city } from "../../api/ControllApi";
import useCachedApi from "../../hooks/useCachedApi";

const FilterDataCard = ({
  onFilterChange,
  PropertyType,
  stateList,
  priceMin,
  priceMax,
  areaMin,
  areaMax,
  isResidental = false,
  isRental
}) => {
  const safePropertyType = Array.isArray(PropertyType) ? PropertyType : [];
  const safeStateList = Array.isArray(stateList) ? stateList : [];
  const { requestApi } = useCachedApi();


  const isSyncingFromProps = useRef(true); 
  const firstRender = useRef(true);
  const prevSearchRef = useRef("");
  const prevPriceRangeRef = useRef([]);
  const prevAreaRangeRef = useRef([]);
  const plotTypeClearedRef = useRef(false);


  const [searchQuery, setSearchQuery] = useState("");
  const [plotType, setPlotType] = useState([]);
  
  const [countries, setCountries] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const [countrySearch, setCountrySearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");


  const initialPriceRange = [0, 0];
  const [priceRange, setPriceRange] = useState(initialPriceRange);
  const [priceInput, setPriceInput] = useState(initialPriceRange.map(String));

 
  const initialAreaRange = [0, 0];
  const [areaRange, setAreaRange] = useState(initialAreaRange);
  const [areaInput, setAreaInput] = useState(initialAreaRange.map(String));



  const ITEM_HEIGHT = 48;
  const MAX_ITEMS_VISIBLE = 3;


  useEffect(() => {
    const pRange = [Number(priceMin) || 0, Number(priceMax) || 0];
    setPriceRange(pRange);
    setPriceInput(pRange.map(String));
    prevPriceRangeRef.current = pRange;

    const aRange = [Number(areaMin) || 0, Number(areaMax) || 0];
    setAreaRange(aRange);
    setAreaInput(aRange.map(String));
    prevAreaRangeRef.current = aRange;

    isSyncingFromProps.current = false; // release lock
  }, [priceMin, priceMax, areaMin, areaMax]);

  
useEffect(() => {
  if (firstRender.current || isSyncingFromProps.current) return;

  // If plotType is cleared and we haven't called API yet
  if (!isRental && plotType.length === 0 && !plotTypeClearedRef.current) {
    plotTypeClearedRef.current = true;
    if (onFilterChange) {
      onFilterChange({ plotType: [] });
    }
  } else if (plotType.length > 0) {
    // Reset the ref when user selects again
    plotTypeClearedRef.current = false;
  }
}, [plotType, isRental]);


  const fetchCountries = async (search = "") => {
    try {
      const res = await requestApi(`countries-${search}`, () => get_country({ search }));
      setCountries(res?.data || []);
    } catch (err) {

    }
  };

  const fetchStates = async (countryId, search = "") => {
    try {
      const res = await requestApi(`states-${countryId}-${search}`, () =>
        get_state({ country_id: countryId, search })
      );
      setStatesList(res?.data || []);
    } catch (err) {

    }
  };

  const fetchCities = async (stateId, search = "") => {
    try {
      const res = await requestApi(`cities-${stateId}-${search}`, () =>
        get_city({ state_id: stateId, search })
      );
      setCitiesList(res?.data || []);
    } catch (err) {

    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchCountries(countrySearch);
    }, 500);
    return () => clearTimeout(timer);
  }, [countrySearch]);

  useEffect(() => {
    if (selectedCountry) {
      const timer = setTimeout(() => {
        fetchStates(selectedCountry.id, stateSearch);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setStatesList([]);
    }
  }, [selectedCountry, stateSearch]);

  useEffect(() => {
    if (selectedState) {
      const timer = setTimeout(() => {
        fetchCities(selectedState.id, citySearch);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setCitiesList([]);
    }
  }, [selectedState, citySearch]);

  // ------------------- Filter change -------------------
  useEffect(() => {
    if (firstRender.current || isSyncingFromProps.current) {
      firstRender.current = false;
      return;
    }

    const filters = {};
    if (selectedCountry) filters.country_id = selectedCountry.id;

    if (selectedState) {
      filters.state_id = selectedState.id;
      filters.states = selectedState.id;
    }
    if (selectedCity) {
      filters.city_id = selectedCity.id;
      filters.city = selectedCity.id;
    }
    
    if (!isRental && plotType.length > 0) {
      filters.plotType = plotType;
    }

    
    const trimmedQuery = searchQuery.trim();
    const prevTrimmed = (prevSearchRef.current || "").trim();
    if (trimmedQuery) filters.searchQuery = trimmedQuery;
    else if (prevTrimmed && !trimmedQuery) filters.searchQuery = "";
    prevSearchRef.current = searchQuery;

    // Price
    const priceChanged =
      prevPriceRangeRef.current[0] !== priceRange[0] ||
      prevPriceRangeRef.current[1] !== priceRange[1];
    if (priceChanged) {
      const defaultPrice = [Number(priceMin) || 0, Number(priceMax) || 0];
      const isDefaultPrice =
        priceRange[0] === defaultPrice[0] && priceRange[1] === defaultPrice[1];
      filters.priceRange = isDefaultPrice ? null : priceRange;
      prevPriceRangeRef.current = priceRange;
    }

    // Area
      if (!isRental) {

    const areaChanged =
      prevAreaRangeRef.current[0] !== areaRange[0] ||
      prevAreaRangeRef.current[1] !== areaRange[1];
    if (areaChanged) {
      const defaultArea = [Number(areaMin) || 0, Number(areaMax) || 0];
      const isDefaultArea =
        areaRange[0] === defaultArea[0] && areaRange[1] === defaultArea[1];
      filters.areaRange = isDefaultArea ? null : areaRange;
      prevAreaRangeRef.current = areaRange;
    }
  }
    if (Object.keys(filters).length > 0 && onFilterChange) {
      const timer = setTimeout(() => onFilterChange(filters), 700);
      return () => clearTimeout(timer);
    }
  }, [selectedCountry, selectedState, selectedCity, plotType, searchQuery, priceRange, areaRange, isRental]);

  // ------------------- Reset -------------------
  const handleReset = () => {
    setSelectedCountry(null);
    setSelectedState(null);
    setSelectedCity(null);
    setCountrySearch("");
    setStateSearch("");
    setCitySearch("");
    setPlotType([]);
    setSearchQuery("");

    const pRange = [Number(priceMin) || 0, Number(priceMax) || 0];
    setPriceRange(pRange);
    setPriceInput(pRange.map(String));
    prevPriceRangeRef.current = pRange;

    const aRange = [Number(areaMin) || 0, Number(areaMax) || 0];
    setAreaRange(aRange);
    setAreaInput(aRange.map(String));
    prevAreaRangeRef.current = aRange;

    if (onFilterChange) onFilterChange({});
  };

 
  const handlePriceSliderChange = (e, newValue) => {
    if (Array.isArray(newValue)) {
      setPriceRange(newValue);
      setPriceInput(newValue.map(String));
    }
  };
  const handleAreaSliderChange = (e, newValue) => {
    if (Array.isArray(newValue)) {
      setAreaRange(newValue);
      setAreaInput(newValue.map(String));
    }
  };
  const handlePriceInputChange = (index, val) => {
    const newInput = [...priceInput];
    newInput[index] = val;
    setPriceInput(newInput);
  };
  const handleAreaInputChange = (index, val) => {
    const newInput = [...areaInput];
    newInput[index] = val;
    setAreaInput(newInput);
  };
  // const handlePriceInputBlur = (index) => {
  //   let val = Number(priceInput[index]);
  //   if (isNaN(val)) val = index === 0 ? Number(priceMin) || 500 : Number(priceMax) || 5000000;
  //   const newRange = [...priceRange];
  //   if (index === 0) newRange[0] = Math.min(val, priceRange[1]);
  //   else newRange[1] = Math.max(val, priceRange[0]);
  //   setPriceRange(newRange);
  //   setPriceInput(newRange.map(String));
  // };
  const handlePriceInputBlur = (index) => {
    const minPrice = Number(priceMin) || 0;
    const maxPrice = Number(priceMax) || 0;

    let val = Number(priceInput[index]);

    if (isNaN(val) || val < minPrice) val = minPrice;
    if (val > maxPrice) val = maxPrice;

    const newRange = [...priceRange];
    if (index === 0) newRange[0] = Math.min(val, priceRange[1]);
    else newRange[1] = Math.max(val, priceRange[0]);

    setPriceRange(newRange);
    setPriceInput(newRange.map(String));
  };

  const handleAreaInputBlur = (index) => {
    const minArea = Number(areaMin) || 0;
    const maxArea = Number(areaMax) || 0;

    let val = Number(areaInput[index]);

    if (isNaN(val) || val < minArea) val = minArea;
    if (val > maxArea) val = maxArea;

    const newRange = [...areaRange];
    if (index === 0) newRange[0] = Math.min(val, areaRange[1]);
    else newRange[1] = Math.max(val, areaRange[0]);

    setAreaRange(newRange);
    setAreaInput(newRange.map(String));
  };



  // const handleAreaInputBlur = (index) => {
  //   let val = Number(areaInput[index]);
  //   if (isNaN(val)) val = index === 0 ? Number(areaMin) || 592 : Number(areaMax) || 100000;
  //   const newRange = [...areaRange];
  //   if (index === 0) newRange[0] = Math.min(val, areaRange[1]);
  //   else newRange[1] = Math.max(val, areaRange[0]);
  //   setAreaRange(newRange);
  //   setAreaInput(newRange.map(String));
  // };

  // ------------------- JSX -------------------
  return (
    <Box sx={{ width: { lg: 300, sm: "auto-fit", xs: "auto-fit" }, py: 2, px: 5, m: "auto", backgroundImage: `url("assets/images/plootbg.png")`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", borderRadius: 6, boxShadow: 3, color: "black" }}>
      {/* Header */}
      <Box sx={{ display: "flex", mb: 1, justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ fontWeight: "600", fontSize: { xs: 14, md: 17 } }}>Filter</Typography>
        <Button color="secondary" onClick={handleReset} startIcon={<RestartAltIcon />}>Reset</Button>
      </Box>

      {/* Search */}
      <Box mb={2}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Search</Typography>
        <TextField 
          placeholder={isResidental ? "Search your property" : "Search your property"} 
          value={searchQuery} 
          onChange={(e) => setSearchQuery(e.target.value)} 
          fullWidth 
          size="small" 
          variant="outlined" 
        />
      </Box>

      {/* Country */}
      {isResidental && (
        <Box mb={2}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>Country</Typography>
          <Autocomplete
            size="small"
            options={countries}
            getOptionLabel={(option) => option.country_name || ""}
            value={selectedCountry}
            onChange={(event, newValue) => {
              setSelectedCountry(newValue);
              setSelectedState(null);
              setSelectedCity(null);
            }}
            onInputChange={(event, newInputValue) => {
              setCountrySearch(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Search Country" variant="outlined" />
            )}
          />
        </Box>
      )}

      {/* State */}
      <Box mb={2}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>State</Typography>
        <Autocomplete
          size="small"
          options={isResidental ? statesList : safeStateList}
          getOptionLabel={(option) => option.state_name || ""}
          value={selectedState}
          disabled={isResidental && !selectedCountry}
          onChange={(event, newValue) => {
            setSelectedState(newValue);
            setSelectedCity(null);
          }}
          onInputChange={(event, newInputValue) => {
            setStateSearch(newInputValue);
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Search State" variant="outlined" />
          )}
        />
      </Box>

      {/* City */}
      <Box mb={2}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>City</Typography>
        <Autocomplete
          size="small"
          options={citiesList}
          getOptionLabel={(option) => option.city_name || ""}
          value={selectedCity}
          disabled={!selectedState}
          onChange={(event, newValue) => {
            setSelectedCity(newValue);
          }}
          onInputChange={(event, newInputValue) => {
            setCitySearch(newInputValue);
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Search City" variant="outlined" />
          )}
        />
      </Box>

      {/* Plot Type */}
      {!isRental && (
      <Box mb={2}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          {isResidental ? "Property Type" : "Plot Type"}
        </Typography>
        <Autocomplete
          multiple
          size="small"
          options={safePropertyType}
          getOptionLabel={(option) => option.category_name}
          value={safePropertyType.filter((p) => plotType.includes(p.id))}
          onChange={(event, newValue) => setPlotType(newValue.map((v) => v.id))}
          disableCloseOnSelect
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox icon={<CheckBoxOutlineBlank fontSize="small" />} checkedIcon={<CheckBox fontSize="small" />} style={{ marginRight: 8 }} checked={selected} />
              {option.category_name}
            </li>
          )}
          renderTags={(value, getTagProps) => (
            <Box sx={{ maxHeight: 72, overflowY: "auto", display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {value.map((option, index) => <Chip label={option.category_name} {...getTagProps({ index })} size="small" />)}
            </Box>
          )}
          ListboxProps={{
            sx: {
              maxHeight: 48 * 4, // 4 items visible, each ~48px
              overflowY: "auto"
            }
          }}
          renderInput={(params) => <TextField {...params} placeholder={plotType.length === 0 ? "Select Property" : ""} InputLabelProps={{ shrink: false }} />}
        />
      </Box>
         )}

      {/* Price */}
      <Box mb={2}>
        <Typography variant="subtitle2">Price Range </Typography>
        <Slider value={priceRange} onChange={handlePriceSliderChange} min={Number(priceMin) || 0} max={Number(priceMax) || 0} step={500} valueLabelDisplay="auto" />
        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
          {/* <TextField label="Min" type="number" size="small" value={priceInput[0]} onChange={(e) => handlePriceInputChange(0, e.target.value)} onBlur={() => handlePriceInputBlur(0)} onKeyDown={(e) => {

            if (e.key === "Enter") {
              e.preventDefault();
              handlePriceInputBlur(0)
            }
          }}
          sx={{
              "& input[type=number]": {
                // Remove arrows in Chrome, Safari, Edge
                "&::-webkit-outer-spin-button": { WebkitAppearance: "none", margin: 0 },
                "&::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
                // Remove arrows in Firefox
                MozAppearance: "textfield",
              },
            }}
 /> */}

          <TextField
            label="Min"
            type="number"
            size="small"
            value={priceInput[0]}
            onChange={(e) => handlePriceInputChange(0, e.target.value)}
            onBlur={() => handlePriceInputBlur(0)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handlePriceInputBlur(0);
              }
            }}
            sx={{
              "& input[type=number]": {
                // Chrome, Safari, Edge
                "&::-webkit-outer-spin-button": { WebkitAppearance: "none", margin: 0 },
                "&::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
                // Firefox
                MozAppearance: "textfield",
              },
            }}
          />

          <TextField
            label="Max"
            type="number"
            size="small"
            value={priceInput[1]}
            onChange={(e) => handlePriceInputChange(1, e.target.value)}
            onBlur={() => handlePriceInputBlur(1)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handlePriceInputBlur(1);
              }
            }}

            sx={{
              "& input[type=number]": {
                "&::-webkit-outer-spin-button": { WebkitAppearance: "none", margin: 0 },
                "&::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
                MozAppearance: "textfield",
              },
            }}
          />


          {/* <TextField label="Max" type="number" size="small" value={priceInput[1]} onChange={(e) => handlePriceInputChange(1, e.target.value)} onBlur={() => handlePriceInputBlur(1)} onKeyDown={(e) => { */}

          {/* if (e.key === "Enter") {
              e.preventDefault();
              handlePriceInputBlur(1)
            }
          }}  fullWidth /> */}
        </Box>
      </Box>

      {/* Area */}
{!isRental && (
      <Box mb={2}>
        <Typography variant="subtitle2">Per Area (Sq Ft)</Typography>
        <Slider value={areaRange} onChange={handleAreaSliderChange} min={Number(areaMin) || 0} max={Number(areaMax) || 0} step={100} valueLabelDisplay="auto" />
        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
          <TextField label="Min" type="number" size="small" value={areaInput[0]} onChange={(e) => handleAreaInputChange(0, e.target.value)} onBlur={() => handleAreaInputBlur(0)} onKeyDown={(e) => {

            if (e.key === "Enter") {
              e.preventDefault();
              handleAreaInputBlur(0)
            }
          }}
            sx={{
              "& input[type=number]": {
                "&::-webkit-outer-spin-button": { WebkitAppearance: "none", margin: 0 },
                "&::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
                MozAppearance: "textfield",
              },
            }}
            fullWidth />
          <TextField label="Max" type="number" size="small" value={areaInput[1]} onChange={(e) => handleAreaInputChange(1, e.target.value)} onBlur={() => handleAreaInputBlur(1)} onKeyDown={(e) => {

            if (e.key === "Enter") {
              e.preventDefault();
              handleAreaInputBlur(1)
            }
          }}
            sx={{
              "& input[type=number]": {
                "&::-webkit-outer-spin-button": { WebkitAppearance: "none", margin: 0 },
                "&::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
                MozAppearance: "textfield",
              },
            }}
            fullWidth />
        </Box>
      </Box>
             )}
    </Box>
  );
};

export default FilterDataCard;
